import React from "react";

const LeadershipItem = ({ position, company, time, project, details }) => {
  return (
    <div className="border-t border-border py-16 md:grid md:grid-cols-12 gap-12 group transition-all duration-500">

      <div className="md:col-span-4 space-y-4">
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-secondary/40">
            {time}
          </span>
        </div>
        <div>
          <h3 className="text-3xl font-bold tracking-tight text-text leading-tight lowercase mb-2">
            {position}
          </h3>
          <p className="text-secondary font-medium text-sm leading-relaxed mt-2">
            {company}
          </p>
        </div>
      </div>

      <div className="md:col-span-8">
        <p className="text-xl font-light italic text-text leading-[1.3] mb-6 tracking-tight">
          {project}
        </p>

        {/* The Narrative - Combining details into paragraphs or a clean narrative list */}
        <div className="space-y-2 max-w-2xl">
          {details.map((point, i) => (
            <div key={i} className="group/text">
              <p className="text-md text-secondary leading-relaxed font-light transition-colors duration-500 group-hover/text:text-text">
                - {point}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Leadership = () => {
  const leadership = [
    {
      position: "VP Finance",
      company: "Professional Engineers of Ontario",
      time: "Jan 2024 - Jan 2025",
      project: "PEO-SC aimed to bridge the gap between students completing engineering degrees and entering the workforce.",
      details: [
        "developed comprehensive budget portfolios and invoices, ensuring precise financial management.",
        "refined contingency plans to address potential financial challenges and ensure business continuity.",
      ],
    },
    {
      position: "Sponsorship & Finance Director",
      company: "Conference in Diversity in Engineering",
      time: "Jan - Dec 2023",
      project: `a weekend of learning and networking focused on fostering inclusivity within engineering communities under the theme "be brave, feel safe, take up pace."`,
      details: [
        "secured conference sponsorships resulting in a 20% increase in revenue through proposal presentations.",
        "managed all delegate invoicing, record-keeping, and cash flow follow-ups.",
      ],
    },
  ];

  return (
    <section id="leadership" className="py-8 bg-background">
      <div className="max-w-6xl mx-auto px-6">

        <div className="mb-16 space-y-2">
          <h2 className="text-sm uppercase tracking-[0.5em] text-secondary font-bold ml-2">
            impact
          </h2>
          <h3 className="text-5xl md:text-6xl font-bold tracking-tighter text-text">
            leadership<span className="italic font-serif text-secondary/40">.</span>
          </h3>
        </div>

        <div className="flex flex-col">
          {leadership.map((item, index) => (
            <LeadershipItem key={index} {...item} />
          ))}
          <div className="border-t border-border"></div>
        </div>
      </div>
    </section>
  );
};

export default Leadership;